import Etapa from "@/Models/Etapa";
import Axios from "@/plugins/Axios";
import store from "@/store";

export class EtapasService {
  async syncAll() {
    const response = await Axios().get("etapas");
    const etapas = response.data.map((etapa) => new Etapa(etapa));
    store.commit("Etapas/setEtapas", etapas);
    return etapas;
  }

  async syncAllEtapasDisponiveis(circuitoId, gestaoDeAulaId) {
    const response = await Axios().get(
      `etapas?circuito_nota_id=${circuitoId}&type=dataAtual&gestaoDeAulaId=${gestaoDeAulaId}`
    );
    const etapas = response.data.todas.map((etapa) => new Etapa(etapa));
    store.commit("Etapas/setEtapas", etapas);
    return { etapas, disponiveis: response.data.disponiveis };
  }

  async getEtapasByCircuitoNotaId(circuitoId) {
    const response = await Axios().get(`etapas?circuito_nota_id=${circuitoId}`);
    const etapas = response.data.todas.map((etapa) => new Etapa(etapa));
    return etapas;
  }

  async criarEtapa(etapa) {
    const response = await Axios().post("etapas", etapa);
    const novoEtapa = response.data;
    store.commit("Etapas/adicionarEtapa", novoEtapa);
    return novoEtapa;
  }

  async atualizarEtapa(circuito) {
    const response = await Axios().put(`etapas/${circuito.id}`, circuito);
    const etapa = response.data;
    store.commit("Etapas/atualizarEtapa", etapa);
    return etapa;
  }

  async deletarEtapa(circuito) {
    const response = await Axios().delete(`etapas/${circuito.id}`);
    const etapaDeletada = response.data;
    store.commit("Etapas/deletarEtapa", circuito.id);
    return etapaDeletada;
  }
}
export default new EtapasService();
